/** @format */

import React, { useRef, useState } from 'react';
import {
  Grid,
  IconButton,
  Button,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import { InputV, SelectV, SimpleDialog, Icons } from 'components';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import { useStyles } from './Style';
import NestedFieldArray from './components/NestedFieldArray';
import { RadioButtonIcon, RadioButtonIconFill } from 'components/CheckBox/RadioButtonIcon';

const BodyParameters = (props) => {
  const { control } = props;
  const methods = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'scInputParams',
  });

  const { scInputParams } = methods.watch();
  const classes = useStyles();

  const childRef = useRef([]);

  const addParam = () => {
    append({
      scParameterName: '',
      scParameterType: '',
      scHiddenParameter: '',
      scParameterDefaultValue: '',
      scParameterLogMode: '',
      scParameterDesc: '',
      typeOfBody: '',
    });
  };

  const [openDialog, setOpenDialog] = useState(false);
  const [indexSelected, setIndexSelected] = useState(-1);

  const removeRow = (index) => {
    setIndexSelected(index);
    setOpenDialog(true);
  };

  const ActionsBtn = () => {
    return (
      <>
        <Button onClick={confirmRemove} variant="contained" color="primary">
          تایید
        </Button>
        <Button onClick={closeDialog} variant="contained">
          انصراف
        </Button>
      </>
    );
  };

  const closeDialog = () => {
    setOpenDialog(false);
  };

  const confirmRemove = () => {
    setOpenDialog(false);
    remove(indexSelected);
    setIndexSelected(-1);
  };

  return (
    <>
      <SimpleDialog
        title="حذف پارامتر Body"
        content="آیا از حذف پارامتر اطمینان دارید؟"
        open={openDialog}
        actions={<ActionsBtn />}
      />
      <Grid container direction="row" alignItems="center" spacing={3}>
        {fields.map((row, index) => {
          return (
            <Grid container item xs={12} key={row.id} className={classes.formGroup}>
              <Grid container item xs={12} spacing={1}>
                <Grid item xs={1}>
                  <IconButton
                    color="primary"
                    variant="contained"
                    aria-label="add"
                    onClick={() => childRef.current[index].addRow()}
                    size="large">
                    <Icons icon="SubdirectoryArrowLeft" color="#343434" size="18" />
                  </IconButton>
                  <IconButton
                    variant="contained"
                    color="secondary"
                    aria-label="delete"
                    onClick={() => removeRow(index)}
                    size="large">
                    <Icons icon="CloseCircle" color="#343434" size="18" />
                  </IconButton>
                </Grid>
                <Grid item xs={1}>
                  <InputV
                    fullWidth
                    errors={methods.formState.errors}
                    name={`scInputParams[${index}].scParameterName`}
                    register={methods.register}
                    rules={['required']}
                    control={methods.control}
                    defaultValue={row.scParameterName}
                    margin="dense"
                  />
                </Grid>
                <Grid item xs={2}>
                  <SelectV
                    name={`scInputParams[${index}].scParameterType`}
                    options={[
                      { value: 'String', label: 'String' },
                      { value: 'Route', label: 'Route' },
                      { value: 'JSon', label: 'JSon' },
                      { value: 'Array', label: 'Array' },
                      { value: 'XML', label: 'XML' },
                      { value: 'Raw', label: 'Raw' },
                    ]}
                    control={methods.control}
                    rules={['required']}
                    errors={methods.formState.errors}
                    fullWidth
                    defaultValue={row.scParameterType || 'String'}
                    margin="dense"
                  />
                </Grid>
                <Grid item xs={3}>
                  { }
                  <Controller
                    name={`scInputParams[${index}].typeOfBody`}
                    control={control}
                    render={({ field: props }) => (
                      <FormControl component="fieldset">
                        <RadioGroup
                          row
                          aria-label="نوع"
                          name={`scInputParams[${index}].typeOfBody`}
                          defaultValue={row.typeOfBody || 'optional'}
                        >
                          <FormControlLabel
                            value="optional"
                            control={
                              <Radio
                                onChange={(e) => props.onChange(e.target.value)}
                                icon={<RadioButtonIcon />}
                                checkedIcon={<RadioButtonIconFill />}
                              />
                            }
                            label="اختیاری"
                            labelPlacement="top"
                          />

                          <FormControlLabel
                            value="required"
                            control={
                              <Radio
                                onChange={(e) => props.onChange(e.target.value)}
                                icon={<RadioButtonIcon />}
                                checkedIcon={<RadioButtonIconFill />}
                              />
                            }
                            label="اجباری"
                            labelPlacement="top"
                          />
                          <FormControlLabel
                            value="hidden"
                            control={
                              <Radio
                                onChange={(e) => props.onChange(e.target.value)}
                                icon={<RadioButtonIcon />}
                                checkedIcon={<RadioButtonIconFill />}
                              />
                            }
                            label="مخفی"
                            labelPlacement="top"
                          />
                        </RadioGroup>
                      </FormControl>
                    )}
                    defaultValue={row.typeOfBody || 'optional'}
                  />
                </Grid>

                <Grid item xs={2}>
                  {fields.length &&
                    scInputParams &&
                    scInputParams.length &&
                    scInputParams[index]?.typeOfBody === 'required' ? (
                    <InputV
                      errors={methods.formState.errors}
                      name={`scInputParams[${index}].scParameterDefaultValue`}
                      register={methods.register}
                      fullWidth
                      control={methods.control}
                      defaultValue=""
                      margin="dense"
                      disabled
                    />
                  ) : (
                    <InputV
                      errors={methods.formState.errors}
                      name={`scInputParams[${index}].scParameterDefaultValue`}
                      register={methods.register}
                      rules={['required']}
                      fullWidth
                      control={methods.control}
                      defaultValue={row.scParameterDefaultValue}
                      margin="dense"
                    />
                  )}
                </Grid>
                <Grid item xs={1}>
                  <SelectV
                    name={`scInputParams[${index}].scParameterLogMode`}
                    options={[
                      { value: 'LOGGABLE', label: 'LOGGABLE' },
                      { value: 'NOT_LOGGABLE', label: 'NOT_LOGGABLE' },
                      { value: 'MASK', label: 'MASK' },
                    ]}
                    control={methods.control}
                    rules={['required']}
                    errors={methods.formState.errors}
                    fullWidth
                    defaultValue={row.scParameterLogMode || 'LOGGABLE'}
                    margin="dense"
                  />
                </Grid>
                <Grid item xs={2}>
                  <InputV
                    fullWidth
                    errors={methods.formState.errors}
                    name={`scInputParams[${index}].scParameterDesc`}
                    register={methods.register}
                    rules={['required']}
                    control={methods.control}
                    defaultValue={row.scParameterDesc}
                    margin="dense"
                  />
                </Grid>
              </Grid>

              <NestedFieldArray
                nestIndex={index}
                control={methods.control}
                register={methods.register}
                errors={methods.formState.errors}
                ref={(el) => (childRef.current[index] = el)}
              />
            </Grid>
          );
        })}
        <Grid item xs={12}>
          <Button color="primary" variant="contained" type="button" onClick={addParam}>
            افزودن
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default BodyParameters;
